import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
// Functions from store
import { createPayment, getPayment } from "../../store";

// @mui material icons

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { toast, ToastContainer } from "react-toastify";
import Cookies from "universal-cookie";

import Modal from "@mui/material/Modal";

const cookies = new Cookies();

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const PaymentPlans = ({ getPayment, getPaymentReducer, createPayment }) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let clientId = loginDetails.data.clientId;
  let userName = loginDetails.data.userName;
  let email = loginDetails.data.email;
  let subscriptionStatus = loginDetails.data.subscriptionStatus;

  const navigate = useNavigate();

  const [plans, setPlans] = useState({});
  useEffect(() => {
    getPayment(jwtToken);
  }, []);

  useEffect(() => {
    let data = getPaymentReducer.payment.data
      ? getPaymentReducer.payment.data
      : [];

    setPlans(data ? data : {});
  }, [getPaymentReducer]);

  const DataUploadSuccessNotification = () =>
    toast.success("Subscribed successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [loading, setLoading] = useState(false);

  const [openDeleteCalendarModal, setOpenDeleteCalendarModal] = useState(false);
  const [singleCalendarDataForDelete, setCalendarDataForDelete] = useState({});
  const handleOpenDeleteCalendarModal = (calendar = {}) => {
    setCalendarDataForDelete(calendar);
    setOpenDeleteCalendarModal(true);
  };
  const handleCloseDeleteCalendarModal = () => {
    setOpenDeleteCalendarModal(false);
  };

  // const plans = {
  //   inr: {
  //     monthly: [
  //       {
  //         name: "Free",
  //         description: "Perfect for small teams getting started",
  //         price: 0,
  //         period: "month",
  //         features: [
  //           "Up to 10 suppliers",
  //           "Basic support",
  //           "Core features",
  //           "Email notifications",
  //           "Basic analytics",
  //         ],
  //         button: "Start Free Trial",
  //         popular: false,
  //       },
  //       {
  //         name: "Pro",
  //         description: "For growing teams that need more power",
  //         price: 200,
  //         period: "month",
  //         features: [
  //           "Up to 200 suppliers",
  //           "Priority support",
  //           "Advanced features",
  //           "Real-time notifications",
  //           "Advanced analytics",
  //           "Custom integrations",
  //           "API access",
  //           "Advanced security",
  //         ],
  //         button: false,
  //         popular: true,
  //       },
  //     ],
  //     quarterly: [
  //       {
  //         name: "Free",
  //         description: "Perfect for small teams getting started",
  //         price: 0,
  //         period: "quarter",
  //         features: [
  //           "Up to 10 users",
  //           "Basic support",
  //           "Core features",
  //           "Email notifications",
  //           "Basic analytics",
  //         ],
  //         button: "Start Free Trial",
  //         popular: false,
  //       },
  //       {
  //         name: "Pro",
  //         description: "For growing teams that need more power",
  //         price: 540, // Example: 10% discount on quarterly
  //         period: "quarter",
  //         features: [
  //           "Up to 200 users",
  //           "Priority support",
  //           "Advanced features",
  //           "Real-time notifications",
  //           "Advanced analytics",
  //           "Custom integrations",
  //           "API access",
  //           "Advanced security",
  //         ],
  //         button: false,
  //         popular: true,
  //       },
  //     ],
  //     yearly: [
  //       {
  //         name: "Free",
  //         description: "Perfect for small teams getting started",
  //         price: 0,
  //         period: "year",
  //         features: [
  //           "Up to 10 users",
  //           "Basic support",
  //           "Core features",
  //           "Email notifications",
  //           "Basic analytics",
  //         ],
  //         button: "Start Free Trial",
  //         popular: false,
  //       },
  //       {
  //         name: "Pro",
  //         description: "For growing teams that need more power",
  //         price: 1920, // Example: 20% discount on yearly
  //         period: "year",
  //         features: [
  //           "Up to 200 users",
  //           "Priority support",
  //           "Advanced features",
  //           "Real-time notifications",
  //           "Advanced analytics",
  //           "Custom integrations",
  //           "API access",
  //           "Advanced security",
  //         ],
  //         button: false,
  //         popular: true,
  //       },
  //     ],
  //   },
  //   usd: {
  //     monthly: [
  //       {
  //         name: "Free",
  //         description: "Perfect for small teams getting started",
  //         price: 0,
  //         period: "month",
  //         features: [
  //           "Up to 10 users",
  //           "Basic support",
  //           "Core features",
  //           "Email notifications",
  //           "Basic analytics",
  //         ],
  //         button: "Start Free Trial",
  //         popular: false,
  //       },
  //       {
  //         name: "Pro",
  //         description: "For growing teams that need more power",
  //         price: 10,
  //         period: "month",
  //         features: [
  //           "Up to 200 users",
  //           "Priority support",
  //           "Advanced features",
  //           "Real-time notifications",
  //           "Advanced analytics",
  //           "Custom integrations",
  //           "API access",
  //           "Advanced security",
  //         ],
  //         button: false,
  //         popular: true,
  //       },
  //     ],
  //     quarterly: [
  //       {
  //         name: "Free",
  //         description: "Perfect for small teams getting started",
  //         price: 0,
  //         period: "quarter",
  //         features: [
  //           "Up to 10 users",
  //           "Basic support",
  //           "Core features",
  //           "Email notifications",
  //           "Basic analytics",
  //         ],
  //         button: "Start Free Trial",
  //         popular: false,
  //       },
  //       {
  //         name: "Pro",
  //         description: "For growing teams that need more power",
  //         price: 27, // Example: 10% discount on quarterly
  //         period: "quarter",
  //         features: [
  //           "Up to 200 users",
  //           "Priority support",
  //           "Advanced features",
  //           "Real-time notifications",
  //           "Advanced analytics",
  //           "Custom integrations",
  //           "API access",
  //           "Advanced security",
  //         ],
  //         button: false,
  //         popular: true,
  //       },
  //     ],
  //     yearly: [
  //       {
  //         name: "Free",
  //         description: "Perfect for small teams getting started",
  //         price: 0,
  //         period: "year",
  //         features: [
  //           "Up to 10 users",
  //           "Basic support",
  //           "Core features",
  //           "Email notifications",
  //           "Basic analytics",
  //         ],
  //         button: "Start Free Trial",
  //         popular: false,
  //       },
  //       {
  //         name: "Pro",
  //         description: "For growing teams that need more power",
  //         price: 96, // Example: 20% discount on yearly
  //         period: "year",
  //         features: [
  //           "Up to 200 users",
  //           "Priority support",
  //           "Advanced features",
  //           "Real-time notifications",
  //           "Advanced analytics",
  //           "Custom integrations",
  //           "API access",
  //           "Advanced security",
  //         ],
  //         button: false,
  //         popular: true,
  //       },
  //     ],
  //   },
  // };

  const periods = [
    { label: "Monthly", discount: 0 },
    { label: "Quarterly", discount: 0 },
    { label: "Yearly", discount: 0 },
  ];

  const currencyOptions = [
    { label: "INR", value: 0 },
    { label: "USD", value: 1 },
  ];

  const [selectedPeriod, setSelectedPeriod] = useState(0);

  const [selectedCurrency, setSelectedCurrency] = useState(0);
  // Choose currency (default to 'usd', you can make this dynamic)
  // const currency = "inr";

  // Get the selected period label
  const periodKey = periods[selectedPeriod].label.toLowerCase();

  const currency = currencyOptions[selectedCurrency].label.toLowerCase();

  // Get plans for selected currency and period
  const currentPlans =
    plans && plans[currency] && plans[currency][periodKey]
      ? plans[currency][periodKey]
      : [];

  const [isErrorDeleteCalendar, setIsErrorDeleteCalendar] = useState(false);
  const [isSuccessDeleteCalendar, setIsSuccessDeleteCalendar] = useState(false);

  useEffect(() => {
    if (isErrorDeleteCalendar) {
      setTimeout(() => {
        setIsErrorDeleteCalendar(false);
      }, 3000);
    }
  }, [isErrorDeleteCalendar]);

  useEffect(() => {
    if (isSuccessDeleteCalendar) {
      setTimeout(() => {
        setIsSuccessDeleteCalendar(false);
      }, 3000);
    }
  }, [isSuccessDeleteCalendar]);

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");

  const deleteCalendarData = async () => {
    setLoading(true);
    const payload = {
      clientId: clientId,

      pricingId: singleCalendarDataForDelete?.pricingId,
      finalPrice: singleCalendarDataForDelete?.price,
      adminUserName: userName,
      adminUserEmail: email,

      planId: singleCalendarDataForDelete?.planId,

      currency: currency,
    };
    let res = await createPayment(payload, jwtToken);

    if (res?.status) {
      setLoading(false);
      DataUploadSuccessNotification();
      handleCloseDeleteCalendarModal();
      setTimeout(() => {
        navigate("/authentication/logout");
      }, 2000);
    }
    if (!res.status) {
      setLoading(false);
      DataUploadFailureNotification(
        res?.data?.data?.msg || "Something went wrong",
      );
      handleCloseDeleteCalendarModal();
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div
        style={{
          display: "flex",

          marginRight: "20px",
          float: "right",
          alignItems: "center",
          flex: 1,
          justifyContent: "flex-end",
          marginTop: "50px",
        }}
      >
        {currencyOptions.map((p, i) => (
          <button
            key={p.label}
            onClick={() => setSelectedCurrency(i)}
            style={{
              padding: "8px 24px",
              marginRight: i !== currencyOptions.length - 1 ? 8 : 0,
              borderRadius: 8,
              border: "none",
              background: selectedCurrency === i ? "#e74c3c" : "#f7f7f7",
              color: selectedCurrency === i ? "white" : "#222",
              fontWeight: selectedCurrency === i ? "bold" : "normal",
              boxShadow:
                selectedCurrency === i
                  ? "0 2px 8px rgba(250, 167, 167, 1)"
                  : "none",
              position: "relative",
              cursor: "pointer",
            }}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div
        style={{ maxWidth: 900, margin: "40px auto", fontFamily: "sans-serif" }}
      >
        <h2 style={{ textAlign: "center" }}>Choose Your Plan</h2>

        <p style={{ textAlign: "center", color: "#888" }}>
          Select the perfect plan for your team. Upgrade or downgrade at any
          time.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "32px 0",
          }}
        >
          {periods.map((p, i) => (
            <button
              key={p.label}
              onClick={() => setSelectedPeriod(i)}
              style={{
                padding: "8px 24px",
                marginRight: i !== periods.length - 1 ? 8 : 0,
                borderRadius: 8,
                border: "none",
                background: selectedPeriod === i ? "#fff0ee" : "#f7f7f7",
                color: "#222",
                fontWeight: selectedPeriod === i ? "bold" : "normal",
                boxShadow: selectedPeriod === i ? "0 2px 8px #f5d0d0" : "none",
                position: "relative",
                cursor: "pointer",
              }}
            >
              {p.label}
              {p.discount > 0 && (
                <span style={{ color: "#e74c3c", fontSize: 12, marginLeft: 4 }}>
                  {p.discount}% off
                </span>
              )}
            </button>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            gap: 32,
            justifyContent: "center",
            marginTop: 32,
          }}
        >
          {Array.isArray(currentPlans) && currentPlans.length > 0 ? (
            currentPlans.map((plan, idx) => (
              <div
                key={plan.name}
                style={{
                  flex: 1,
                  minWidth: 320,
                  border: !plan.popular ? "1px solid #f5d0d0" : "none",
                  borderRadius: 16,
                  padding: 32,
                  background: "#fff",
                  position: "relative",
                  boxShadow: !plan.popular ? "0 4px 24px #f5d0d0" : "none",
                }}
              >
                {plan.popular && (
                  <div
                    style={{
                      position: "absolute",
                      top: 16,
                      right: 16,
                      background: "#e74c3c",
                      color: "#fff",
                      fontSize: 12,
                      borderRadius: 8,
                      padding: "2px 12px",
                      fontWeight: "bold",
                    }}
                  >
                    Coming Soon
                  </div>
                )}
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 18,
                    textAlign: "center",
                  }}
                >
                  {plan.name}
                </div>
                <div
                  style={{
                    color: "#888",
                    textAlign: "center",
                    marginBottom: 16,
                  }}
                >
                  {plan.description}
                </div>
                <div style={{ textAlign: "center", margin: "24px 0" }}>
                  <span style={{ fontSize: 40, fontWeight: "bold" }}>
                    {plan.currencySign} {plan.price}
                  </span>
                  <span style={{ color: "#888", fontSize: 18 }}>
                    /{plan.period}
                  </span>
                </div>
                <ul style={{ listStyle: "none", padding: 0, marginBottom: 24 }}>
                  {plan.features.map((f) => (
                    <li key={f} style={{ marginBottom: 12, color: "#222" }}>
                      <span style={{ color: "#e74c3c", marginRight: 8 }}>
                        ✓
                      </span>
                      {f}
                    </li>
                  ))}
                </ul>
                {!plan.popular &&
                  (subscriptionStatus ? (
                    <button
                      disabled
                      style={{
                        width: "86%",
                        padding: "10px",
                        borderRadius: 8,
                        border: "1px solid #eee",
                        background: "#4caf50",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: 16,
                        cursor: "none",
                        position: "absolute",

                        // position: "relative",
                        left: 30,
                        right: 30,
                        bottom: 35,
                      }}
                      onClick={async () => {
                        setLoading(true);
                        const payload = {
                          clientId: clientId,

                          pricingId: plan.pricingId,
                          finalPrice: plan.price,
                          adminUserName: userName,
                          adminUserEmail: email,

                          planId: plan.planId,

                          currency: currency,
                        };
                        let res = await createPayment(payload, jwtToken);

                        if (res?.status) {
                          setLoading(false);
                          DataUploadSuccessNotification();
                          setTimeout(() => {
                            navigate("/authentication/logout");
                          }, 2000);
                        }
                        if (!res.status) {
                          setLoading(false);
                          DataUploadFailureNotification(
                            res?.data?.data?.msg || "Something went wrong",
                          );
                        }
                      }}
                    >
                      Current Plan
                    </button>
                  ) : (
                    <button
                      style={{
                        width: "86%",
                        padding: "10px",
                        borderRadius: 8,
                        border: !plan.popular ? "none" : "1px solid #eee",
                        background: !plan.popular ? "#e74c3c" : "#fff",
                        color: !plan.popular ? "#fff" : "#222",
                        fontWeight: "bold",
                        fontSize: 16,
                        cursor: "pointer",
                        position: "absolute",

                        // position: "relative",
                        left: 30,
                        right: 30,
                        bottom: 35,
                      }}
                      onClick={() => {
                        handleOpenDeleteCalendarModal(plan);
                      }}
                    >
                      {subscriptionStatus ? "Subscribed" : plan.button}
                    </button>
                  ))}
              </div>
            ))
          ) : (
            <div
              style={{
                flex: 1,
                minWidth: 320,
                border: "1px dashed #f5d0d0",
                borderRadius: 16,
                padding: 32,
                background: "#f7f7f7",
                textAlign: "center",
              }}
            >
              <p style={{ color: "#888" }}>Plan details coming soon...</p>
            </div>
          )}
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: 32,
            color: "#888",
            fontSize: 15,
          }}
        >
          {/* All plans include a 14-day free trial. No credit card required.
          <br /> */}
          Need a custom plan?{" "}
          <a
            href="https://mobillor.com/contact-us"
            style={{ color: "#e74c3c" }}
          >
            Contact us
          </a>
        </div>
      </div>
      <div>
        <Modal
          open={openDeleteCalendarModal}
          onClose={handleCloseDeleteCalendarModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDCard sx={deleteStyle}>
            <MDTypography>Are you sure you want to confirm?</MDTypography>
            <MDBox mt={2} display="flex">
              <div>
                <MDButton
                  style={{ width: "100%", marginRight: "0.5rem" }}
                  color="info"
                  variant="outlined"
                  onClick={handleCloseDeleteCalendarModal}
                >
                  Cancel
                </MDButton>
              </div>
              <div style={{ float: "right" }}>
                <MDButton
                  style={{ width: "100%", marginLeft: "0.5rem" }}
                  color="success"
                  onClick={deleteCalendarData}
                >
                  Confirm
                </MDButton>
              </div>
            </MDBox>
            {/* <MDBox mt={2}>
              <Collapse in={isErrorDeleteCalendar}>
                <Alert
                  severity="error"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setIsErrorDeleteCalendar(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  {deleteErrorMsg}
                </Alert>
              </Collapse>
            
            </MDBox> */}
          </MDCard>
        </Modal>
      </div>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <ToastContainer />
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getPaymentReducer: state.getPaymentReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPayment: (jwtToken) => dispatch(getPayment(jwtToken)),
    createPayment: (payload, jwtToken) =>
      dispatch(createPayment(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPlans);
